import { AxiosResponse } from "axios";
import { Moment } from "moment";

import { http } from "../api-http";
import { Station } from "../models/station.model";
import { DashboardStation } from "../models/dashboard/dashboard-station.model";
import { DashboardIndicators } from "../models/dashboard/dashboard-indicators.model";
import { DashboardHistory } from "../models/dashboard/dashboard-history.model";
import { List } from "../models/list.model";

export class DashboardService {

    private static _instance: DashboardService | null = null;

    static getInstance(): DashboardService {
        if (!DashboardService._instance) {
            DashboardService._instance = new DashboardService();
        }
        return DashboardService._instance;
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {
    }

    getStations(group: string, since: Moment, before: Moment): Promise<DashboardStation[]> {
        return http.get<DashboardStation[]>(
            `/api/avolta-connect/dashboard/${group}/stations`, 
            { 
                params: {
                    since: since.unix(),
                    before: before.unix(),
                }
            }
        ).then((response: AxiosResponse<DashboardStation[]>) => {
            return response.data.filter((station: Station) => ['avolta-ch4', 'avolta-lorawan', 'avolta-ltem'].includes(station.type));
        })
    }

    getIndicators(group: string, since: Moment, before: Moment): Promise<DashboardIndicators> {
        return http.get<DashboardIndicators>(
            `/api/avolta-connect/dashboard/${group}/indicators`, 
            { 
                params: {
                    since: since.unix(),
                    before: before.unix(),
                }
            }
        ).then((response: AxiosResponse<DashboardIndicators>) => {
            return response.data;
        })
    }

    getHistory(group: string, since: Moment, before: Moment, step: number): Promise<DashboardHistory[]> {
        return http.get<List<DashboardHistory>>(
            `/api/avolta-connect/dashboard/${group}/history`, 
            { 
                params: {
                    since: since.unix(),
                    before: before.unix(),
                    step: step,
                }
            }
        ).then((response: AxiosResponse<List<DashboardHistory>>) => {
            return response.data.data;
        })
    }


}